export default function Hero() {
  return (
    <div className="relative min-h-screen pt-20 bg-white overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-8 py-20 flex items-center min-h-[calc(100vh-80px)]">
        {/* Left Content Zone */}
        <div className="w-[42%] pr-12">
          <div className="inline-block border border-[#d0d0d0] rounded-sm px-4 py-2 mb-32">
            <span className="text-[11px] uppercase tracking-[1.5px] text-[#888] font-medium">
              EST. 2024 / iOS SPECIALISTS
            </span>
          </div>

          <div className="mb-16">
            <h1 className="leading-[0.95]">
              <div className="flex items-center gap-3 mb-1">
                <span className="text-[72px] font-extrabold text-black">
                  Crafting Premium
                </span>
                <span className="text-[32px]">🚀</span>
              </div>
              <div className="text-[72px] font-light italic text-[#6b5b7d]" style={{ fontFamily: 'Georgia, serif' }}>
                iOS Experiences
              </div>
            </h1>
          </div>

          <p className="text-[16px] leading-[1.7] text-[#4a4a4a] w-[85%] mb-12">
            MIKRA d.o.o. is a team of experts developing modern applications for the iOS platform. Our products, such as VPN and Cleaner, are designed to enhance user experience and improve the security of mobile devices.
          </p>

          <div className="inline-block border-b-2 border-[#2a2a2a] pb-1">
            <span className="text-[15px] font-medium text-[#2a2a2a] cursor-pointer">
              Explore our approach
            </span>
          </div>
        </div>

        {/* Right Visual Zone */}
        <div className="w-[58%] relative h-[600px]">
          {/* Card 1 - VPN */}
          <div className="absolute top-10 left-0 w-[280px] h-[280px] rounded-[24px] overflow-hidden shadow-[0_12px_40px_rgba(0,0,0,0.08)]">
            <img
              src="https://public.readdy.ai/ai/img_res/18f2bc64c00fe8d0c758903e9d0b0872.jpg"
              alt="VPN App Interface"
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Card 2 - Cleaner */}
          <div className="absolute top-32 right-0 w-[320px] h-[420px] rounded-[24px] overflow-hidden shadow-[0_16px_48px_rgba(0,0,0,0.12)]">
            <img
              src="https://readdy.ai/api/search-image?query=elegant%20iOS%20cleaner%20application%20interface%20on%20iPhone%2C%20minimalist%20white%20UI%20design%2C%20storage%20optimization%20graphics%2C%20clean%20modern%20aesthetic%2C%20light%20mode%20interface%20with%20soft%20shadows%2C%20circular%20progress%20indicators%2C%20premium%20mobile%20app%20design%2C%20professional%20product%20shot%2C%20simple%20white%20background&width=320&height=420&seq=cleaner001&orientation=portrait"
              alt="Cleaner App Interface"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
